export default __webpack_public_path__ + "static/media/AppraisalWF6.199b9c8e.png";